// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"379":"92fb8cc8","446":"d66d4568"}[chunkId] + ".js";
};